import React from "react"
import { Button } from "~/ui/button"
import { EmptyList } from "~/ui/empty-list"

interface Tag {
  id: string
  name: string
}

interface FilteredEmptyStateProps {
  // Filter state
  selectedTags: string[]
  allTags: Tag[]
  onClearFilters: () => void

  // Content for filtered state
  itemType: string // "contacts", "invitations", etc.
  filteredTitle?: string

  // Content for non-filtered state
  emptyTitle: string
  emptyDescription: string
  emptyAction: React.ReactNode

  // Optional additional action for filtered state
  filteredAction?: React.ReactNode
}

export function FilteredEmptyState({
  selectedTags,
  allTags,
  onClearFilters,
  itemType,
  filteredTitle,
  emptyTitle,
  emptyDescription,
  emptyAction,
  filteredAction,
}: FilteredEmptyStateProps) {
  const getSelectedTagNames = () => {
    return selectedTags
      .map((tagId) => allTags.find((tag) => tag.id === tagId)?.name)
      .filter(Boolean)
  }

  if (selectedTags.length > 0) {
    const tagNames = getSelectedTagNames().join(", ")
    const title =
      filteredTitle || `No Matching ${itemType.charAt(0).toUpperCase() + itemType.slice(1)}`
    const description = `No ${itemType} found with the selected tag${selectedTags.length === 1 ? "" : "s"}: ${tagNames}`

    return (
      <EmptyList
        title={title}
        description={description}
        cta={
          <div className="space-y-2">
            <Button onClick={onClearFilters}>Clear Filters</Button>
            {filteredAction}
          </div>
        }
      />
    )
  }

  return <EmptyList title={emptyTitle} description={emptyDescription} cta={emptyAction} />
}
